import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { useFormContext } from 'react-hook-form'

import { FormSubmitButton } from '@twisto/components/atoms/button'
import {
  PasswordStrengthRuleList,
  defaultPasswordRulesMap,
  defaultPasswordValidations,
  getPasswordStrength,
} from '@twisto/components/atoms/password-strength'
import { TextField } from '@twisto/components/molecules/text-field'
import { validator } from '@twisto/form'

import { useFlow } from '../../flow/flow.context'

import * as styles from './password-step-form-content.styles'

export const passwordFieldName = 'password' as const

export type PasswordFormValues = {
  [passwordFieldName]: string
}

export const PasswordStepFormContent = () => {
  const { watch } = useFormContext<PasswordFormValues>()
  const { flow } = useFlow<'PasswordStep'>()
  const { password } = flow.currentStep

  const validate = {
    isStrongPassword: validator.createStrongPassword(
      Object.values(defaultPasswordRulesMap)
    ),
  }

  const validatedRulesMap = getPasswordStrength(
    watch(passwordFieldName),
    defaultPasswordRulesMap
  )

  return (
    <div css={styles.container}>
      <TextField
        ariaLabel={/*i18n*/ i18n._('flow.passwordStep.inputLabel')}
        inputProps={{
          autoComplete: 'off',
          autoFocus: true,
          readOnly: password.readonly,
        }}
        label={<Trans id="flow.passwordStep.inputLabel" />}
        name={passwordFieldName}
        rules={{
          required:
            password.required && validator.getValidationMessages().required,
          validate,
        }}
        variant="password"
      />

      <div css={styles.passwordStrengthSection}>
        <PasswordStrengthRuleList
          rulesMap={validatedRulesMap}
          rulesNodes={{
            lowerCase: defaultPasswordValidations.lowerCase(1),
            upperCase: defaultPasswordValidations.upperCase(1),
            specialChar: defaultPasswordValidations.specialChar(1),
            minLength: defaultPasswordValidations.minLength(),
          }}
        />
      </div>
      <FormSubmitButton>
        <Trans id="flow.passwordStep.submitButton" />
      </FormSubmitButton>
    </div>
  )
}
